// extracted by mini-css-extract-plugin
export default {"media":"Image_media__LjkUB","card":"Image_card__cFJvh","hero":"Image_hero__s0A2n","banner":"Image_banner__5J3Um"};